import {
	type ActivatedRouteSnapshot,
	BaseRouteReuseStrategy,
} from "@angular/router";

export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
	override shouldReuseRoute(
		future: ActivatedRouteSnapshot,
		curr: ActivatedRouteSnapshot,
	): boolean {
		const { reuseRoute: futureReuseRoute } = future.data;
		const { reuseRoute: currReuseRoute } = curr.data;
		if (futureReuseRoute === true && currReuseRoute === true) {
			return true;
		}
		return future.routeConfig === curr.routeConfig;
	}
}
